<!--  -->
<template>
    <div class='wrapper' id="middle2_right">
        <div class="title1">解决问题</div>
        <div class="tr" :style="'height:'+height">
            <div id="scroll_wrapper_resolve" :style="'height:'+contentheight+';marginTop:'+marginTop">
                <div class="list_item box" v-for="(item,index) in list" 
                    :key="index" 
                    :class="{'active':index==selectIndex}"
                    :style="'height:'+itemHeight"
                >
                    <div class="box box_f1" >
                        <div class="box_f1 box box_v">
                            <div class="box" style="align-items:center">
                                <div class="dot"></div>
                                <div class="slh" style="width:240px">{{item.questionInfo}}</div>
                            </div>
                            <div class="area">{{item.userName}}</div>
                        </div>
                        <div class="item_text" style="width:150px">{{item.createTime}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            list:[],
            height:'100%',
            contentheight:'100%',
            selectIndex:0,
            marginTop:"0px",
            timer:null,
            itemHeight:'60px'
        };
    },
    props:{
        show:{
            type:Boolean,
            default:false
        }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        show:{
            handler(newVal){
                if(newVal){
                    this.list=[]
                    this.selectIndex = 0
                    this.marginTop ='0px' 
                    this.getData()
                }else{
                     console.log('left1.destroy')
                    this.timer && clearInterval(this.timer)
                }
            },
            immediate:true
        }
    },
    //方法集合
    methods: {
        getData(){
            this.$post(this.urlobj.questionList,{
                type:2,
                pageNum:1,
                pageSize:10
            }).then(res=>{
               this.list = res.rows

               this.handelScroll()
            })
        },
        handelScroll(){
            let height = document.getElementById('middle2_right').offsetHeight - 67
            this.height = height + 'px'
            let itemHeight = height/5-10   
            this.itemHeight = itemHeight + 'px'

            let num = 1
            let contentheight = this.list.length * itemHeight
            this.contentheight = contentheight + 'px'
        
            if(height<contentheight){
                //没有显示完整
                this.timer = setInterval(()=>{
                    if(num*(itemHeight+10)<contentheight){
                        this.selectIndex = this.selectIndex+1
                        this.marginTop ='-'+num*(itemHeight+10)+'px'
                        num++
                    }else{
                        this.selectIndex = 0
                        num = 1
                        this.marginTop ='-'+num*(itemHeight+10)+'px'
                    }
                },3000)
            }
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.wrapper{
    background-image: url('../../../../assets/images/monitorpy/bottom.png');
    background-size: 100% 100%;
}
.title1{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin:20px 0 20px 40px
}
.tr{
    width:100%;
    padding: 0 10px 10px 10px;
    //flex-wrap:wrap;
    overflow: hidden;
    #scroll_wrapper{
        //transition-timing-function: linear;
        //display: flex;
        //flex-wrap: wrap;
        width: 100%
    }
}
.list_item{
    margin: 0 0px 10px 0px;
    border-top:1px dashed #00A0E9;
    border-bottom: 1px dashed #00A0E9;
    align-items: center;
    color:#00D6B2;
    font-size: 14px;
    .dot{
        background: #97DE00;
        border-radius: 50%;
        height:8px;
        width:8px;
        margin-right:5px
    }
    .area{
        width: 56px;
        height: 16px;
        background: #FF8A51;
        border-radius: 0px 8px 0px 8px;
        text-align: center;
        color:#061B54;
        font-size: 14px;
        line-height: 16px;
        margin-left: 13px;
        margin-top: 2px;
    }
    .item_text{
        color:#00D6B2
    }

}
.active{
        box-shadow:0 0 20px #00A0E9 inset; 
    // border:none;
    // color:#34FFB5;
}
</style>